export class ProcedureType {

    public id: string;
    public name: string;
    public description: string;

    constructor(other ?: ProcedureType) {
        if (other) {
            this.id = other.id;
            this.name = other.name;
            this.description = other.description;
        }
    }

    toString() {
        return this.description;
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/procedureType.ts
 **/